import { useReveal } from "../hooks/useReveal";
import { ROADMAP } from "../lib/copy";

export default function Roadmap() {
  const ref = useReveal();
  return (
    <section ref={ref} className="border-y" style={{ borderColor: "rgba(255,255,255,0.08)" }} data-testid="roadmap-section">
      <div className="max-w-[1400px] mx-auto grid md:grid-cols-4">
        {ROADMAP.map((step, i) => (
          <div key={i} className="roadmap-col reveal-slide" data-testid={`roadmap-step-${i + 1}`}>
            <span className="roadmap-num">{step.num}</span>
            <p className="eyebrow mb-4">{step.label}</p>
            <h3 className="font-black uppercase text-2xl mb-4">{step.name}</h3>
            <p className="text-sm" style={{ color: "var(--muted)", lineHeight: 1.7 }}>{step.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
